import { render, staticRenderFns } from "./RadioButtons.vue?vue&type=template&id=6a40280f"
import script from "./RadioButtons.vue?vue&type=script&lang=js"
export * from "./RadioButtons.vue?vue&type=script&lang=js"
import style0 from "./RadioButtons.vue?vue&type=style&index=0&id=6a40280f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports